/*
 * alleseins24: keeps the shop's own product blocks (Auswahl, Lieferinfo, technische Daten)
 * in step with the theme's variant picker. The picker only re-renders itself, so this reads
 * the selected option values, finds the matching variant in the JSON printed by the
 * a24-variant-data snippet and announces it as an "a24:variant" event on the document.
 */
(() => {
  if (window.a24VariantSync) return;
  window.a24VariantSync = true;

  const readProduct = () => {
    const script = document.querySelector('script[data-a24-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };

  const findVariant = (picker, product) => {
    const chosen = {};
    picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      chosen[input.dataset.optionName] = input.value;
    });
    return product.variants.find((variant) =>
      product.options.every((name, index) => !(name in chosen) || variant.options[index] === chosen[name])
    );
  };

  document.addEventListener('change', (event) => {
    const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    if (!picker) return;
    const product = readProduct();
    if (!product) return;
    const variant = findVariant(picker, product);
    if (variant) document.dispatchEvent(new CustomEvent('a24:variant', { detail: variant }));
  });
})();
